import Flatpickr from 'react-flatpickr';
import { handleDateRangeChange } from '../../helpers/helpers';

export const DateRangeFilter = ({
  searchParams,
  setSearchParams,
  param,
  noPagination,
  hasTime,
  hasDirectorInfo
}: {
  searchParams: URLSearchParams;
  setSearchParams: any;
  param?: string;
  noPagination?: boolean;
  hasTime?: boolean;
  hasDirectorInfo?: boolean;
}) => {
  const from = searchParams.get(param || 'fromDate') || '';
  const to = searchParams.get(param || 'toDate') || '';

  return (
    <div className='mb-2 d-inline-block col-12'>
      <Flatpickr
        className='form-control'
        id='datepicker-publish-input'
        placeholder='Select a date'
        options={
          hasDirectorInfo
            ? {
                enableTime: hasTime,
                time_24hr: true,
                altInput: true,
                altFormat: hasTime ? 'd M Y, H:i' : 'd M Y',
                dateFormat: hasTime ? 'Y-m-d H:i' : 'Y-m-d',
                mode: 'range',
                maxDate: 'today',
                minDate: '2026-01-15'
              }
            : {
                enableTime: hasTime,
                time_24hr: true,
                altInput: true,
                altFormat: hasTime ? 'd M Y, H:i' : 'd M Y',
                dateFormat: hasTime ? 'Y-m-d H:i' : 'Y-m-d',
                mode: 'range',
                maxDate: 'today'
                // minDate: '2026-01-15'
              }
        }
        onChange={(e) => {
          handleDateRangeChange(e, setSearchParams, noPagination, hasTime);
        }}
        value={[from, to]}
      />
    </div>
  );
};
